<template lang="pug">
div
  .md-headline Distribution Domain
  .md-subheading.domain-hint Enter the domain where this distribution is served
  md-input-container.domain-input(:class='{ "md-input-invalid": showDomainError }')
    span.md-error(v-if='showDomainError') Enter a valid domain (e.g. example.com)
    label Domain
    md-input(
      v-model='playerSettings.domain',
      type='text',
      placeholder='example.com'
    )
  .domain-preview(v-if='playerSettings.domain')
    span.domain-label Preview URL structure:&nbsp;
    code.domain-example {{ normalizedDomain }}?videoSlug=video-slug-123456
</template>

<script>
  export default {
    props: {
      playerSettings: {
        type: Object,
        required: true
      },
      isLive: {
        type: Boolean,
        default: false
      },
      formSubmitted: {
        type: Boolean,
        default: false
      },
      validations: {
        type: Object,
        default: null
      }
    },
    computed: {
      normalizedDomain() {
        if (!this.playerSettings.domain) return '';
        return this.playerSettings.domain
          .trim()
          .replace(/^https?:\/\//i, '')
          .replace(/\/+$/, '');
      },
      showDomainError() {
        return (
          this.formSubmitted
          && this.validations
          && this.validations.domain
          && this.validations.domain.$invalid
        );
      },
    }
  };
</script>

<style lang="scss" scoped>
  .domain-hint {
    margin-bottom: 12px;
    color: #777;
    font-size: 0.9em;
  }
  .domain-input {
    width: 100%;
  }
  .domain-preview {
    margin-top: 10px;
    font-size: 0.85em;
    color: #555;
    word-break: break-all;
  }
  .domain-label {
    font-weight: 600;
  }
  .domain-example {
    background: #f4f4f4;
    border-radius: 3px;
    padding: 2px 6px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/PlayerSettingsForm.vue